import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import { useTheme } from '../../../theme-context';

interface ITicketBoughtLine {
    ticket: {
        price: string;
        row: string;
        seat: string;
        section: string;
        tier: string;
        username: string;
    };
}

const TicketBoughtLine = ({
    ticket,
}: ITicketBoughtLine): React.ReactElement => {
    const { section, row, seat, tier, price, username } = ticket;
    const { getFont } = useTheme();
    return (
        <div>
            <div
                data-testid="ticket-bought-line"
                className={css({
                    padding: '16px 16px 8px',
                })}
            >
                <div
                    data-testid="username"
                    className={css({
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium/bold').lineHeightPx
                        }px`,
                        marginBottom: '8px',
                    })}
                >
                    {username}
                </div>
                <div
                    className={css({
                        display: 'grid',
                        gridTemplateColumns: 'repeat(5, auto);',
                    })}
                >
                    <div
                        className={css({
                            fontFamily:
                                getFont('desktop/body/small').fontFamily,
                            fontWeight:
                                getFont('desktop/body/small').fontWeight,
                            fontSize: getFont('desktop/body/small').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/small').lineHeightPx
                            }px`,
                            marginBottom: '4px',
                        })}
                    >
                        {gettext('Section')}
                    </div>
                    <div
                        className={css({
                            fontFamily:
                                getFont('desktop/body/small').fontFamily,
                            fontWeight:
                                getFont('desktop/body/small').fontWeight,
                            fontSize: getFont('desktop/body/small').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/small').lineHeightPx
                            }px`,
                            marginBottom: '4px',
                        })}
                    >
                        {gettext('Row')}
                    </div>
                    <div
                        className={css({
                            fontFamily:
                                getFont('desktop/body/small').fontFamily,
                            fontWeight:
                                getFont('desktop/body/small').fontWeight,
                            fontSize: getFont('desktop/body/small').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/small').lineHeightPx
                            }px`,
                            marginBottom: '4px',
                        })}
                    >
                        {gettext('Seat')}
                    </div>
                    <div
                        className={css({
                            fontFamily:
                                getFont('desktop/body/small').fontFamily,
                            fontWeight:
                                getFont('desktop/body/small').fontWeight,
                            fontSize: getFont('desktop/body/small').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/small').lineHeightPx
                            }px`,
                            marginBottom: '4px',
                        })}
                    >
                        {gettext('Tier')}
                    </div>
                    <div
                        className={css({
                            fontFamily: getFont('desktop/body/medium')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/small').lineHeightPx
                            }px`,
                            marginBottom: '4px',
                        })}
                    >
                        {gettext('Price')}
                    </div>
                    <div
                        data-testid="section"
                        className={css({
                            alignSelf: 'center',
                            fontFamily: getFont('desktop/body/medium')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/medium').lineHeightPx
                            }px`,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                        })}
                    >
                        {section}
                    </div>
                    <div
                        data-testid="row"
                        className={css({
                            alignSelf: 'center',
                            fontFamily: getFont('desktop/body/medium')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/medium').lineHeightPx
                            }px`,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                        })}
                    >
                        {row}
                    </div>
                    <div
                        data-testid="seat"
                        className={css({
                            alignSelf: 'center',
                            fontFamily: getFont('desktop/body/medium')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium').fontSize,
                            lineHeight: `${
                                getFont('desktop/body/medium').lineHeightPx
                            }px`,
                        })}
                    >
                        {seat}
                    </div>
                    <div
                        data-testid="tier"
                        className={css({
                            background: tier,
                            alignSelf: 'center',
                            borderRadius: '50%',
                            width: '14px',
                            height: '14px',
                        })}
                    />
                    <div
                        data-testid="price"
                        className={css({
                            alignSelf: 'center',
                            fontFamily: getFont('desktop/body/medium')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium').fontSize,
                        })}
                    >
                        {price}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketBoughtLine;
